import React from 'react'
import './TableTabs.scss'
const TableTabs = ({ tabs, callBack, current, setPremiumType, premiumType, showPremiumToggle }) => {
  const generateTabs = () => {
    const myTabs = []
    tabs.forEach((tab, index) => {
      const tabValue = typeof (tab) == String ? tab : tab.value
      myTabs.push((
        <div
          tabIndex={index}
          key={index}
          className={
            current === tabValue
              ? 'link pb15 ml5 df ai-fs mr25 fz15 c-blue-700 tdn oln'
              : 'df ai-fs ml5 mr25 fz15 c-neutral-500 tdn oln'}
          onClick={() => callBack(tab)}
        >
          {tabValue}
        </div>))
    })
    return myTabs
  }

  var toggleBtn = {
    width: '45px',
    height: '25px',
    background: 'gray',
    borderRadius: '30px',
    padding: '3px',
    margin: '0 10px'
  }

  var innerCircle = {
    width: '19px',
    height: '19px',
    backgroundColor: 'white',
    borderRadius: '50%',
    marginLeft: premiumType === 'ac' ? 0 : '20px',
    transition: '.4s'
  }

  const togglePremiumType = () => {
    setPremiumType(prev => {
      if (prev === 'ac') {
        return 'bu'
      }
      return 'ac'
    })
  }

  const container = {
    position: 'absolute',
    right: '20px'
  }

  return (
    <div className="df" style={{ position: 'relative' }}>
      <div data-testid='tabs' className='df ai-fs curp ml10 mr25 fz15 tab-display'>{generateTabs()}</div>
      {showPremiumToggle ?
        <div style={container}>
          <div className="df">
            <span>$/ac</span>
            <div style={toggleBtn} onClick={togglePremiumType}>
              <div style={innerCircle}></div>
            </div>
            <span>$/bu</span>
          </div>
        </div> : null}
    </div>
  )
}

export default TableTabs